import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUsers, clearUsers } from '../../../../actions/index';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';

export const CustomerUserSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearUsers,
  dispatchGetUsers,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearUsers(), []);

  const onInputChangeUser = (inputValue) => {
    const trimmed = inputValue.trim();

    if (!trimmed.length) return;

    // Si es numérico → buscar por documento
    if (!Number.isNaN(Number(trimmed))) {
      dispatchGetUsers({
        query: [`customer.idDocumentNumber:${trimmed}`],
      });
      return;
    }

    if (trimmed.length >= 4) {
      const index = trimmed.indexOf(',');
      const query = [];

      if (index >= 0) {
        const firstName = trimmed.substring(0, index).trim();
        const lastName = trimmed.substring(index + 1).trim();

        if (firstName.length) query.push(`customer.firstName:${firstName}`);
        if (lastName.length) query.push(`customer.lastName:${lastName}`);
      } else {
        query.push(`customer.firstName:${trimmed}`);
      }

      dispatchGetUsers({ query });
    }
  };

  const filterOption = (users) => users;

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeUser}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      filterOption={filterOption}
      {...rest}
    />
  );
};

CustomerUserSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetUsers: PropTypes.func.isRequired,
  dispatchClearUsers: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

CustomerUserSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Ingrese Nombre o DNI',
};

const mapStateToProps = ({ UserUnit }) => ({
  options: UserUnit.User.getIn(['all', 'content', 'content']).map((user) => ({
    value: user.customer.id,
    label: user.customer.fullName,
  })),
  loading: UserUnit.User.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetUsers: getUsers,
  dispatchClearUsers: clearUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerUserSelect);
